<template>
  <transition name="modal" v-if="showCompanyModal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click.self="cancelCompany">
        <div class="modal-container">
          <div class="modal-header">
            <h3>Add Company</h3>
          </div>
          <div class="modal-body form-horizontal">
            <!-- FIELD NAME -->
            <div class="form-group">
              <label for="fieldName" class="control-label col-sm-2">Name</label>
              <div class="col-sm-10 input-group">
                <input id="fieldName" class="form-control admin-form-control" type="text" name="name" v-model="newCompany.name" placeholder="Company Name">
              </div>
            </div>
            <div class="clearfix"></div>
            <form-image-uploader
              v-model="newCompany.logo"
              :albumName="'companyLogos'"
              :inputLabel="'Logo'"
              :labelClasses="['col-sm-2']"
              :inputClasses="['col-sm-10']"
              ></form-image-uploader>
          </div>
          <div class="modal-footer">
            <button class="btn btn-default" @click="cancelCompany">Cancel</button>
            <button class="btn admin-btn-primary" @click="addCompany">Add</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions } from 'vuex'
import FormImageUploader from '../../components/FormImageUploader'
import S3 from '../../_helpers/awsS3.js'

export default {
  name: 'AddCompanyModal',
  props: ['showCompanyModal'],
  components: {
    'form-image-uploader': FormImageUploader
  },
  data () {
    return {
      newCompany: {
        name: null,
        logo: { fileName: null, randomString: null, imageKey: null, url: null }
      }
    }
  },
  methods: {
    ...mapActions('company', [ 'createCompany' ]),
    cancelCompany () {
      if (this.newCompany.logo.imageKey) {
        S3.removeFromS3(this.newCompany.logo.imageKey).then(() => {
          this.resetCompany()
          this.$emit('close')
        })
      } else {
        this.resetCompany()
        this.$emit('close')
      }
    },
    addCompany () {
      this.createCompany(this.newCompany)
        .then(() => {
          this.resetCompany()
          this.$emit('close')
        })
        .catch(err => {
          console.log(err)
        })
    },
    resetCompany () {
      Object.assign(this.$data, this.$options.data())
    }
  }
}
</script>

<style scoped>
.modal-enter-active, .modal-leave-active {
  transition: opacity .5s;
}
.modal-enter, .modal-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
